export default __webpack_public_path__ + "media/images/quote-stripes-bcdbbbcc47a747a2ac4d4111627f0280.svg";